import { getAnalyticsSource } from '../../api/analytics/analytics-selectors.js';
export const fromAnalyticsStateToAnalyticsParams = (s, navigatorContext, eventDescription) => {
    return {
        analytics: {
            clientId: navigatorContext.clientId,
            clientTimestamp: new Date().toISOString(),
            documentReferrer: navigatorContext.referrer,
            documentLocation: navigatorContext.location,
            originContext: s.originContext,
            ...(eventDescription && {
                actionCause: eventDescription.actionCause,
            }),
            ...(eventDescription && {
                customData: eventDescription.customData,
            }),
            ...(s.userDisplayName && { userDisplayName: s.userDisplayName }),
            ...(s.deviceId && { deviceId: s.deviceId }),
            ...(s.trackingId && { trackingId: s.trackingId }),
            ...{
                capture: navigatorContext.capture ?? navigatorContext.clientId !== '',
            },
            ...{ source: getAnalyticsSource(s) },
        },
    };
};
